<template>
    <div v-if="show" :class="componentClass">
        <div id="ks-loader-static"></div>
    </div>
</template>

<script>
const COMPONENT_NAME = 'loader';

export default {
    props: ['show', 'loaderClass'],
    name: COMPONENT_NAME,
    computed: {
        componentClass() {
            return this.loaderClass ?? 'loader'
        }
    }
}
</script>

<style scoped>
.loader {
    display: flex;
}
</style>
